<template>
  <div
    class="check-input form-control"
    @click="handleCheckClick(label)"
  >
    <template v-if="checkedItems.length>0">
      <b-badge
        v-for="item in checkedItems"
        :key="item.value"
        class="mr-1 badge-item"
        variant="primary"
      >
        <span>{{ item.label }}</span>
        <feather-icon
          v-if="!disabled"
          class="ml-1"
          icon="XIcon"
          size="22"
          @click.stop="handleCheckedDel(item)"
        />
      </b-badge>
    </template>
    <template v-else>
      {{ $t('_components.placeholder.check')+label }}
    </template>
    <!-- modal -->

    <b-modal
      v-if="modalVisible&&!disabled"
      v-model="modalVisible"
      cancel-variant="outline-secondary"
      :modal-class="{'line-block' : !checkArrayHasChildren}"
      centered
      size="lg"
      :title="modalTitle"
    >
      <check-item
        v-model="selected"
        :data="dictOptions"
        :disabled="disabled"
      />
      <template #modal-footer>
        <b-button
          variant="primary"
          size="sm"
          @click="modelConfirm"
        >
          {{ i18n('btns.confirm') }}
        </b-button>
      </template>
    </b-modal>
  </div>
</template>

<script>

import {
  BBadge, BModal, BButton,
} from 'bootstrap-vue'
import { deepClone } from '@/util/util'
import checkItem from '@/components/myForm/components/checkItem.vue';
import { getDicts, flattenArray } from '../utils'

export default {
  components: {
    BBadge,
    BModal,
    checkItem,
    BButton,
  },
  props: {
    value: {
      type: [String, Number, Object, Array, Boolean],
      default: undefined,
    },
    option: {
      type: Object,
      default: () => ({}),
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    label: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      data: undefined,
      dictOptions: [],
      dictCode: this.option.dictCode || this.option.dictBizCode,
      modalVisible: false,
      modalTitle: 'Title',
      selected: [],
      confirmSelect: [],
      updateNow: this.option.updateNow || false,
    }
  },
  computed: {
    checkedItems() {
      const res = []
      // 数组扁平化
      const menuFormat = data => {
        if (Array.isArray(data)) {
          const dataClone = deepClone(data)
          dataClone.forEach(item => {
            const element = {}
            element.label = item.label
            element.value = item.value
            if (Array.isArray(item.children)) {
              if (item.children.length > 0) {
                element.children = menuFormat(item.children)
              }
            }
            res.push(element)
          })
        }
      }
      menuFormat(this.dictOptions)
      return res.filter(o => this.confirmSelect.indexOf(o.value) !== -1) || []
    },
    checkArrayHasChildren() {
      let bool = false
      this.dictOptions.forEach(item => {
        if (item.children) {
          bool = true
        }
      })
      return bool
    },
  },
  watch: {
    confirmSelect(e) {
      this.$emit('input', e.join())
    },
    value: {
      handler(e) {
        this.initDictOption(e)
      },
      deep: true,
      immediate: true,
    },
    'option.dictData': {
      handler(e) {
        if (e) {
          if (e.length > 0) {
            this.dictOptions = e
          }
        }
      },
      immediate: true,
    },
    'option.dictBizCode': {
      handler(e) {
        if (e && this.updateNow) {
          this.dictCode = e
          this.changeDictOption()
        }
      },
      deep: true,
      immediate: true,
    },
    'option.dictCode': {
      handler(e) {
        if (e && this.updateNow) {
          this.dictCode = e
          this.changeDictOption()
        }
      },
      deep: true,
      immediate: true,
    },
  },
  methods: {
    initDictOption(e) {
      if (this.dictCode && this.dictOptions.length <= 0) {
        getDicts(this.option).then(res => {
          this.dictOptions = res
          if (e) {
            this.selected = e.split(',')
            this.confirmSelect = e.split(',')
          }
        })
      } else if (e) {
        this.selected = e.split(',')
        this.confirmSelect = e.split(',')
      }
    },
    handleCheckClick(label) {
      this.modalVisible = true
      this.modalTitle = label
    },
    modelConfirm() {
      this.modalVisible = false
      if (!this.disabled) {
        this.confirmSelect = this.selected
      }
    },
    // 国际化
    i18n(param) {
      return this.$t(`_components.${param}`)
    },
    handleCheckedDel(item) {
      if (!this.disabled) {
        this.confirmSelect.splice(this.confirmSelect.findIndex(o => o === item.value), 1)
      }
    },
    changeDictOption() {
      getDicts(this.option).then(res => {
        this.dictOptions = res
      })
    },
  },
}

</script>

<style lang='scss'>
@import '@core/scss/vue/libs/vue-select.scss';

.line-block{
  .check-item{
    display: inline-block;
  }
}
</style>

<style lang="scss" scoped>
.check{
  &-input{
    cursor: pointer;
    min-height: 2.714rem;
    height: auto;
    color:rgb(195, 195, 204)
  }
}
.badge-item{
  font-size: 16px;
  cursor: default;
  margin-bottom: 5px;
  margin-top: 5px;
  svg{
    cursor: pointer;
  }
}
.dark-layout{
  .check{
    &-input{
    border-color: #404656;
    background-color: #283046;
    }
  }
}
</style>
